<div class="message is-fullwidth">

  <div class="message-header" (dblclick)="toggleMinimizeFilters()">
    <p i18n>File upload</p>
    <button (click)="toggleMinimizeFilters()">
      <span class="icon is-small">
        @if (!filtersMinimized) {
          <i-feather name="chevron-up"></i-feather>
        } @else {
          <i-feather name="chevron-down"></i-feather>
        }
      </span>
    </button>
  </div>

  @if (!filtersMinimized) {
    <div class="message-body">
      <div class="is-flex is-flex-direction-row is-flex-wrap-wrap filter-row unisized-labels checkbox-row">
        <div class="is-flex is-flex-direction-column" style="width: 400px">
          <div class="label label-select">
            <div class="label label-select">
              <span i18n>sFB Action</span>
              <div class="select is-fullwidth">
                <select [(ngModel)]="sfbAction" (change)="clearData()">
                  <ng-container>
                    @for (type of sfbActionFilters; track type) {
                      <option [ngValue]="type.value">
                        {{ type.label }}
                      </option>
                    }
                  </ng-container>
                </select>
              </div>
            </div>
          </div>
          <div class="is-italic">
            <span i18n>Required columns:</span>
            <br>
              <span>{{findRequiredColumns()}}</span>
            </div>
          </div>
          <div class="is-flex is-flex-direction-column" style="width: 400px">
            <div class="file has-name is-boxed is-info" style="display: inline-block; width: auto;">
              <label class="file-label" style="display: flex; align-items: center;">
                <input class="file-input" type="file" accept="text/csv" onclick="this.value = null"
                  (change)="onSfbFileSelected($event)">
                <span class="file-cta" style="flex-grow: 1;">
                  <span class="file-icon">
                    <i-feather name="upload"></i-feather>
                  </span>
                  <span class="file-label" i18n>
                Choose a file…
              </span>
                </span>
              </label>
            </div>
          </div>
          <div class="is-flex is-flex-direction-column" style="width: 400px">
            @if (selectedSfbFiles.length > 0) {
              <div class="tags">
                @for (file of selectedSfbFiles; track file; let i = $index) {
                  <div style="display: block;">
                    <span class="tag is-info is-medium">
                      {{file.name}}
                    </span>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }

  </div>

  @if (assignments.length >= 1 && sfbAction === 'assign') {
    <div class="json-viewer-wrapper">
      @if (!readingFile) {
        <ngx-json-viewer [json]="assignments"></ngx-json-viewer>
      }
      @if (readingFile) {
        <ngx-json-viewer [json]="{}"></ngx-json-viewer>
      }
    </div>
  }

  @if (unaAssignments.length >= 1 && sfbAction === 'unassign') {
    <div class="json-viewer-wrapper">
      @if (!readingFile) {
        <ngx-json-viewer [json]="unaAssignments"></ngx-json-viewer>
      }
      @if (readingFile) {
        <ngx-json-viewer [json]="{}"></ngx-json-viewer>
      }
    </div>
  }

  @if (assignments.length >= 1 || unaAssignments.length >=1) {
    <nav class="navbar is-fixed-bottom">
      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <button class="button is-info" (click)="clearData()">
              <strong i18n>Clear</strong>
            </button>
            <button class="button is-primary" (click)="sendSfbChanges()">
              <strong i18n>Send changes</strong>
            </button>
          </div>
        </div>
      </div>
    </nav>
  }

  @if (loading) {
    <div class="notification">
      <span class="loader-mixin"></span>
      <p i18n>Assignments are being sent...</p>
    </div>
  }